export interface DuplicatePlateConflict {
    id: string;
    name: string | null;
    licensePlate: string;
}

interface DuplicatePlateErrorShape {
    response?: {
        status?: number;
        data?: {
            error?: string;
            conflictVehicle?: DuplicatePlateConflict;
        };
    };
}

export function getDuplicatePlateConflict(
    error: unknown,
): DuplicatePlateConflict | null {
    const response = (error as DuplicatePlateErrorShape)?.response;
    if (
        response?.status === 409 &&
        response.data?.error === 'duplicate_license_plate' &&
        response.data.conflictVehicle
    ) {
        return response.data.conflictVehicle;
    }
    return null;
}

export function isSamePlate(a?: string | null, b?: string | null): boolean {
    return (a ?? '').trim().toLowerCase() === (b ?? '').trim().toLowerCase();
}
